import React, { useState } from 'react';
import { Tabs, Loader } from 'kangarootime-ui';
import WeekView from './WeekView';
import moment from 'moment';
import '../shared/Table.css';

const RoomViewTable = ({
  shiftsGroupedByDay,
  employeesById,
  roomsById,
  projectedRoomAttendance,
  roomRatios,
  datesInVisibleWeek,
  createNewShift,
  isLoading,
  editShift,
  copyShift,
  deleteShift,
  schedulesNetworkAction,
  hideCreateShiftButton // clicking on the table is disabled until loading has completed or the week has a valid schedule
}) => {
  const [activeDayView, setActiveDayView] = useState('week');
  const isWeekView = activeDayView === 'week';

  const dayIndex = day => {
    switch (day) {
      case 'monday': return 0;
      case 'tuesday': return 1;
      case 'wednesday': return 2;
      case 'thursday': return 3;
      case 'friday': return 4;
      default: return 0;
    }
  };

  /**
   * create an object where the key is an employee id and the value is their number of hours worked for the week
   * structure of `shifts` is expected to be N level of nested objects and where N+1 level is an array
   *
   * @param {Object} shifts
   */
  const calculateMinutesWorkedForWeek = shifts => {
    // recursive function that returns an array containing the values of the provided object
    const flattenObject = obj => {
      let objectContents = [];

      // array was provided
      if (Array.isArray(obj)) {
        return obj;
      }

      Object.keys(obj).forEach(key => {
        let value = obj[key];

        if (typeof value === 'object' && Object.keys(value).length > 0) {
          value = flattenObject(value);
        }

        objectContents = objectContents.concat(value);
      });

      return objectContents;
    };

    let employees = {};
    let objectContents = flattenObject(shifts);

    if (objectContents.length) {
      objectContents.forEach(shift => {
        const { employeeId, start, end, breakMinutes } = shift;
        const minutesWorkedInShift = (moment(end).diff(moment(start), 'minutes') - breakMinutes);

        if (employees[employeeId]) {
          employees[employeeId] += minutesWorkedInShift;
        } else {
          employees[employeeId] = minutesWorkedInShift;
        }
      });
    }

    return employees;
  };

  return (
    <Loader loading={isLoading}>
      <React.Fragment>
        <Tabs
          tabs={[
            { label: 'Weekly', value: 'week' },
            { label: 'Monday', value: 'monday' },
            { label: 'Tuesday', value: 'tuesday' },
            { label: 'Wednesday', value: 'wednesday' },
            { label: 'Thursday', value: 'thursday' },
            { label: 'Friday', value: 'friday' }
          ]}
          activeTabView={activeDayView}
          handleTabChange={value => setActiveDayView(value)}
        />
        <div style={{ opacity: schedulesNetworkAction ? 0.5 : 1 }}>
          <WeekView
            shiftsGroupedByDay={isWeekView ? shiftsGroupedByDay : { [activeDayView]: shiftsGroupedByDay[activeDayView] }}
            roomsById={roomsById}
            employeesById={employeesById}
            minutesWorkedForWeekByEmployee={calculateMinutesWorkedForWeek(shiftsGroupedByDay)}
            projectedRoomAttendance={projectedRoomAttendance}
            roomRatios={roomRatios}
            datesInVisibleWeek={isWeekView ? datesInVisibleWeek : [datesInVisibleWeek[dayIndex(activeDayView)]]}
            singleDayView={!isWeekView}
            createNewShift={createNewShift}
            editShift={editShift}
            copyShift={copyShift}
            deleteShift={deleteShift}
            showCreateButton={!hideCreateShiftButton}
          />
        </div>
      </React.Fragment>
    </Loader>
  );
};

export default RoomViewTable;
